import { PackageVariantClosedCheckIcon } from './PackageVariantClosedCheckIcon';

/**
 * author: Hans Böhm
 * id CAA724DF-E0C7-4010-8265-0C2E594D3094
 * name package-variant-closed-check
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/package-variant-closed-check.svg
 * tags
 */
export const PackageVariantClosedDeliveredIcon = PackageVariantClosedCheckIcon;
export default PackageVariantClosedDeliveredIcon